/**
 * TVFMO — The View From My Office
 * Shopify theme JavaScript
 * 
 * Handles:
 * 1. Variant picker (size cards + format toggle → hidden select sync)
 * 2. Price updates on variant change
 * 3. Add-to-cart form state
 * 4. Cart discount progress messaging
 */

(function () {
  'use strict';

  /* ── 1. VARIANT PICKER ─────────────────────────────────── */

  function initVariantPickers() {
    var containers = document.querySelectorAll('.tvfmo-variants');
    containers.forEach(function (container) {
      initSinglePicker(container);
    });
  }

  function initSinglePicker(container) {
    var productId = container.dataset.productId;
    var dataEl = document.getElementById('tvfmo-variant-data-' + productId);
    if (!dataEl) return;

    var variants = JSON.parse(dataEl.textContent);
    var hiddenSelect = document.getElementById('tvfmo-variant-select-' + productId);
    if (!hiddenSelect) return;

    var sizeCards = container.querySelectorAll('.tvfmo-size-card input[type="radio"]');
    var formatBtns = container.querySelectorAll('.tvfmo-format-btn input[type="radio"]');

    function getSelectedOptions() {
      var size = null;
      var format = null;

      sizeCards.forEach(function (radio) {
        if (radio.checked) size = radio.value;
      });

      formatBtns.forEach(function (radio) {
        if (radio.checked) format = radio.value;
      });

      return { size: size, format: format };
    }

    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;

        if (options.size !== null && v.option1 !== options.size) match = false;
        if (options.format !== null) {
          // Format could be option1 (Safe Harbour) or option2 (standard)
          if (sizeCards.length > 0) {
            if (v.option2 !== options.format) match = false;
          } else {
            if (v.option1 !== options.format) match = false;
          }
        }

        if (match) return v;
      }
      return null;
    }

    function updateUI(variant) {
      // Update hidden select
      if (variant) {
        hiddenSelect.value = variant.id;
      }

      // Update size card selected states
      sizeCards.forEach(function (radio) {
        var card = radio.closest('.tvfmo-size-card');
        if (radio.checked) {
          card.classList.add('is-selected');
        } else {
          card.classList.remove('is-selected');
        }
      });

      // Update format button selected states
      formatBtns.forEach(function (radio) {
        var btn = radio.closest('.tvfmo-format-btn');
        if (radio.checked) {
          btn.classList.add('is-selected');
        } else {
          btn.classList.remove('is-selected');
        }
      });

      // Update the product page price display
      var priceEl = document.querySelector('[data-current-price]');
      if (priceEl && variant) {
        if (variant.price === 999900) {
          priceEl.textContent = 'Price coming soon';
        } else {
          priceEl.textContent = formatMoney(variant.price);
        }
      }

      // Update add-to-cart button state
      var addBtn = container.closest('form')
        ? container.closest('form').querySelector('[type="submit"]')
        : null;

      if (addBtn) {
        if (!variant) {
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
        } else if (!variant.available) {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold out';
        } else if (variant.price === 999900) {
          addBtn.disabled = true;
          addBtn.textContent = 'Price coming soon';
        } else {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to cart';
        }
      }

      // Update size card prices for current format
      updateSizeCardPrices();

      // Update URL without page reload (for shareability)
      if (variant && history.replaceState) {
        var url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }

    function updateSizeCardPrices() {
      var options = getSelectedOptions();

      sizeCards.forEach(function (radio) {
        var card = radio.closest('.tvfmo-size-card');
        var priceSpan = card.querySelector('[data-size-price]');
        if (!priceSpan) return;

        var testOptions = {
          size: radio.value,
          format: options.format
        };
        var v = findVariant(testOptions);

        if (v) {
          card.classList.remove('is-unavailable');
          radio.disabled = false;
          if (v.price === 999900) {
            priceSpan.textContent = 'Price coming soon';
            priceSpan.className = 'tvfmo-size-card__price tvfmo-size-card__price--tbd';
          } else {
            priceSpan.textContent = formatMoney(v.price);
            priceSpan.className = 'tvfmo-size-card__price';
          }
        } else {
          card.classList.add('is-unavailable');
          radio.disabled = true;
        }
      });
    }

    function onChange() {
      var options = getSelectedOptions();
      var variant = findVariant(options);
      updateUI(variant);
    }

    // Bind events
    sizeCards.forEach(function (radio) {
      radio.addEventListener('change', onChange);
    });

    formatBtns.forEach(function (radio) {
      radio.addEventListener('change', onChange);
    });
  }

  /* ── 2. MONEY FORMATTING ───────────────────────────────── */

  function formatMoney(cents) {
    // Shopify stores prices in cents (e.g. 13500 = $135.00)
    // Respect the store's money format if available
    var amount = (cents / 100).toFixed(2);

    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return '$' + amount + ' ' + window.Shopify.currency.active;
    }

    return '$' + amount + ' USD';
  }

  /* ── 3. CART DISCOUNT PROGRESS ─────────────────────────── */

  function initCartDiscountProgress() {
    var progressEl = document.querySelector('.tvfmo-cart-discount');
    if (!progressEl) return;

    // Read item count from the cart data
    // This runs on the cart page where Shopify exposes cart data
    if (typeof window.Shopify !== 'undefined' && window.Shopify.cart) {
      updateDiscountProgress(window.Shopify.cart.item_count);
    }
  }

  function updateDiscountProgress(itemCount) {
    var progressEl = document.querySelector('.tvfmo-cart-discount');
    if (!progressEl) return;

    var messageEl = progressEl.querySelector('.tvfmo-cart-discount__message');
    var barEl = progressEl.querySelector('.tvfmo-cart-discount__bar');

    if (itemCount >= 6) {
      if (messageEl) messageEl.textContent = '15% collector\u2019s discount applied.';
      if (barEl) barEl.style.width = '100%';
    } else if (itemCount >= 3) {
      if (messageEl) messageEl.textContent = '10% collector\u2019s discount applied. Add ' + (6 - itemCount) + ' more for 15% off.';
      if (barEl) barEl.style.width = '66%';
    } else {
      var remaining = 3 - itemCount;
      if (messageEl) messageEl.textContent = 'Add ' + remaining + ' more print' + (remaining === 1 ? '' : 's') + ' for 10% off.';
      if (barEl) barEl.style.width = (itemCount / 3 * 33) + '%';
    }
  }

  /* ── 4. ZIMBABWE VISITOR BANNER ────────────────────────── */

  function initZwBanner() {
    var banner = document.getElementById('tvfmo-zw-banner');
    if (!banner) return;

    // Check if dismissed this session
    try {
      if (sessionStorage.getItem('tvfmo-zw-banner-dismissed')) return;
    } catch (e) { /* storage unavailable, show banner */ }

    function checkCountry() {
      // Shopify Markets exposes the selected country in the
      // localization form or the country-selector button text.
      var countryEl = document.querySelector(
        '[data-country-code],' +
        'localization-form [name="country_code"],' +
        '.disclosure__toggle[aria-controls*="country"]'
      );
      var code = '';

      if (countryEl) {
        code = (countryEl.value || countryEl.dataset.countryCode || '').toUpperCase();
      }

      // Fallback: read from the visible selector text
      if (!code) {
        var selectorText = document.querySelector(
          '.localization-selector .disclosure__toggle,' +
          '.header__localize button'
        );
        if (selectorText && /zimbabwe/i.test(selectorText.textContent)) {
          code = 'ZW';
        }
      }

      if (code === 'ZW') {
        banner.style.display = 'block';
      } else {
        banner.style.display = 'none';
      }
    }

    // Check on load
    checkCountry();

    // Re-check when the country selector changes
    var observer = new MutationObserver(function () {
      setTimeout(checkCountry, 300);
    });

    var header = document.querySelector('.header');
    if (header) {
      observer.observe(header, { childList: true, subtree: true, characterData: true });
    }

    // Close button
    var closeBtn = banner.querySelector('.tvfmo-zw-banner__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        banner.style.display = 'none';
        try {
          sessionStorage.setItem('tvfmo-zw-banner-dismissed', '1');
        } catch (e) { /* ignore */ }
      });
    }
  }

  /* ── 5. NZ STRETCHED RESTRICTION (A0 + A1) ──────────────
     On Shopify Basic, we cannot exclude specific variants from
     specific markets via admin settings. This JS approach
     detects New Zealand visitors and disables Statement (A0)
     and Gallery (A1) Stretched combinations, showing a brief
     notice instead. Rolled remains available in all sizes.
     ──────────────────────────────────────────────────────── */

  function initNzRestriction() {
    function isNZ() {
      // Check visible selector text
      var selectorText = document.querySelector(
        '.localization-selector .disclosure__toggle,' +
        '.header__localize button'
      );
      if (selectorText && /new zealand/i.test(selectorText.textContent)) {
        return true;
      }
      // Check hidden form value
      var countryEl = document.querySelector(
        '[data-country-code],' +
        'localization-form [name="country_code"]'
      );
      if (countryEl) {
        var code = (countryEl.value || countryEl.dataset.countryCode || '').toUpperCase();
        if (code === 'NZ') return true;
      }
      return false;
    }

    // Restricted: Gallery (A1) Stretched, Statement (A0) Stretched
    var RESTRICTED_SIZES = ['Gallery (A1)', 'Statement (A0)'];

    function applyRestriction() {
      if (!isNZ()) {
        // Remove any existing notice
        var existing = document.querySelector('.tvfmo-nz-notice');
        if (existing) existing.style.display = 'none';
        return;
      }

      var containers = document.querySelectorAll('.tvfmo-variants');
      containers.forEach(function (container) {
        var sizeCards = container.querySelectorAll('.tvfmo-size-card input[type="radio"]');
        var formatBtns = container.querySelectorAll('.tvfmo-format-btn input[type="radio"]');

        // Find current selections
        var selectedFormat = null;
        formatBtns.forEach(function (radio) {
          if (radio.checked) selectedFormat = radio.value;
        });

        var selectedSize = null;
        sizeCards.forEach(function (radio) {
          if (radio.checked) selectedSize = radio.value;
        });

        // Check if current selection is restricted
        var isRestricted = false;
        if (selectedFormat === 'Stretched') {
          RESTRICTED_SIZES.forEach(function (prefix) {
            if (selectedSize && selectedSize.indexOf(prefix) === 0) {
              isRestricted = true;
            }
          });
        }

        // Show/hide notice
        var notice = container.querySelector('.tvfmo-nz-notice');
        if (!notice) {
          notice = document.createElement('div');
          notice.className = 'tvfmo-nz-notice';
          notice.textContent = 'Stretched canvas in Gallery (A1) and Statement (A0) sizes is not available for delivery to New Zealand. These sizes are available as rolled canvas.';
          container.appendChild(notice);
        }

        notice.style.display = isRestricted ? 'block' : 'none';

        // Disable the add-to-cart button if restricted
        var addBtn = container.closest('form')
          ? container.closest('form').querySelector('[type="submit"]')
          : null;
        if (addBtn && isRestricted) {
          addBtn.disabled = true;
          addBtn.textContent = 'Not available for New Zealand';
        }
      });
    }

    // Run on variant change
    document.addEventListener('change', function (e) {
      if (e.target.closest('.tvfmo-variants')) {
        setTimeout(applyRestriction, 50);
      }
    });

    // Run on load
    applyRestriction();

    // Re-check when country changes
    var observer = new MutationObserver(function () {
      setTimeout(applyRestriction, 300);
    });
    var header = document.querySelector('.header');
    if (header) {
      observer.observe(header, { childList: true, subtree: true, characterData: true });
    }
  }

  /* ── 6. INITIALISE ─────────────────────────────────────── */

  function init() {
    initVariantPickers();
    initCartDiscountProgress();
    initZwBanner();
    initNzRestriction();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section render (theme editor live preview)
  document.addEventListener('shopify:section:load', function () {
    initVariantPickers();
    initNzRestriction();
  });

})();
